import type { CloserLead } from '@/types'

const PENDING_PROPOSAL_STAGE = 'proposta_elaboracao'
const STORAGE_KEY = 'closer-leads:pending-proposal'

export type PendingProposalSession = {
  dealId: string
  leadId?: string
  empresa?: string
  savedAt: string
}

export function normalizeDealStage(etapa?: string | null): string {
  return (etapa || '').trim().toLowerCase()
}

export function getLeadPrimaryDeal(lead: CloserLead) {
  if (lead.deals?.length) return lead.deals[0]
  if (lead.dealId) {
    return { id: lead.dealId, nome: lead.empresa, etapa: '', valor: 0, probabilidade: 0, createdAt: lead.updatedAt }
  }
  return undefined
}

export function isLeadPendingProposalElaboration(lead: CloserLead): boolean {
  const deal = getLeadPrimaryDeal(lead)
  if (!deal?.id) return false
  return normalizeDealStage(deal.etapa) === PENDING_PROPOSAL_STAGE
}

export function shouldKeepLeadInActiveWallet(lead: CloserLead): boolean {
  const status = (lead.status || '').toUpperCase()
  if (status !== 'CONVERTIDO') return false
  return isLeadPendingProposalElaboration(lead)
}

export function savePendingProposalSession(data: Omit<PendingProposalSession, 'savedAt'>) {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...data, savedAt: new Date().toISOString() } satisfies PendingProposalSession),
    )
  } catch {
    /* quota / private mode */
  }
}

export function readPendingProposalSession(): PendingProposalSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PendingProposalSession
    if (!parsed?.dealId) return null
    return parsed
  } catch {
    return null
  }
}

export function clearPendingProposalSession() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}

export function findLeadForPendingSession(leads: CloserLead[], session: PendingProposalSession) {
  return leads.find(
    (lead) =>
      lead.id === session.leadId ||
      lead.dealId === session.dealId ||
      lead.deals?.some((deal) => deal.id === session.dealId),
  )
}
